// Twilio's 1600-character body limit counts GSM-7 units when the message fits the GSM-7
// charset (extended-table characters cost 2 units each). Any character outside GSM-7 forces
// the whole message into UCS-2, where the limit counts UTF-16 code units instead.
// https://www.twilio.com/docs/glossary/what-sms-character-limit
const GSM7_BASIC =
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?" +
  "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
const GSM7_EXTENDED = "^{}\\[~]|€";

export const twilioMessageLength = (text: string): number => {
  let gsmUnits = 0;
  for (const char of text) {
    if (GSM7_BASIC.includes(char)) {
      gsmUnits += 1;
    } else if (GSM7_EXTENDED.includes(char)) {
      gsmUnits += 2;
    } else {
      return text.length;
    }
  }
  return gsmUnits;
};
